import { render, staticRenderFns } from "./BlocoDeBagsECrediario.vue?vue&type=template&id=8b80c4aa&scoped=true&"
import script from "./BlocoDeBagsECrediario.vue?vue&type=script&lang=ts&"
export * from "./BlocoDeBagsECrediario.vue?vue&type=script&lang=ts&"
import style0 from "./BlocoDeBagsECrediario.vue?vue&type=style&index=0&id=8b80c4aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b80c4aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
